export function getServiceProductPrice(service, clientProvidesProduct = false) {
  if (!service?.produit_fournissable) {
    return Number(service?.basePrice ?? service?.price ?? 0);
  }

  if (clientProvidesProduct) {
    return Number(service?.prix_sans_produit ?? service?.basePrice ?? service?.price ?? 0);
  }

  return Number(service?.basePrice ?? service?.prix_avec_produit ?? service?.price ?? 0);
}

export function buildServiceWithProductChoice(service, clientProvidesProduct = false) {
  const basePrice = getServiceProductPrice(service, clientProvidesProduct);
  return {
    ...service,
    basePrice,
    price: basePrice,
    clientProvidesProduct: Boolean(clientProvidesProduct),
  };
}

export function getDefaultMaterial(materials = []) {
  return materials.find((material) => material.is_default) || materials[0] || null;
}

export function getServicePriceWithoutMaterial(service) {
  return Number(service?.prixSansMateriel ?? service?.basePrice ?? service?.price ?? 0);
}

export function buildOtherMaterialQuoteService(service) {
  return {
    ...buildServiceWithMaterial(service, null),
    PricingModel: 'sur devis',
    otherMaterialRequested: true,
  };
}

export function buildServiceWithMaterial(service, material = null) {
  const prixSansMateriel = getServicePriceWithoutMaterial(service);
  const materialPrice = material ? Number(material.prix) || 0 : 0;
  const basePrice = prixSansMateriel + materialPrice;
  return {
    ...service,
    otherMaterialRequested: false,
    prixSansMateriel,
    selectedMaterial: material
      ? { id: material.id, nom: material.nom, prix: materialPrice, image_url: material.image_url || '' }
      : null,
    materialPrice,
    basePrice,
    price: basePrice,
  };
}
